/**
 * App trip virtual guide states.
 *
 * Don't forget to update if needed
 */
export default {
	ENABLED: "enabled",
	DISABLED: "disabled",
};
